import { useState, useEffect, useCallback } from 'react';
import apiClient from '../utils/api';

/**
 * Custom hook for Fitbit connection status
 * Handles fetching and refreshing Fitbit connection status
 */
export const useFitbitStatus = () => {
  const [fitbitStatus, setFitbitStatus] = useState({ connected: false, connected_at: null });
  const [loading, setLoading] = useState(true);

  const fetchFitbitStatus = useCallback(async () => {
    try {
      setLoading(true);
      const response = await apiClient.get('/api/auth/fitbit/status');
      if (response.status === 200) {
        setFitbitStatus(response.data);
      }
    } catch (error) {
      console.error('Error fetching Fitbit status:', error);
      setFitbitStatus({ connected: false, connected_at: null });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchFitbitStatus();
    
    // Refresh when page becomes visible (e.g., returning from OAuth flow)
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        fetchFitbitStatus();
      }
    };
    
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [fetchFitbitStatus]);

  return { fitbitStatus, loading, refetch: fetchFitbitStatus };
};

